<template>
    <a-spin :spinning="isLoading">
        <a-row type="flex" align="middle" justify="space-between" class="mb-1">
            <a-col>
                <h1 class="mb-0">Anuncios</h1>
            </a-col>
            <a-col v-if="loggedUserIsAdmin">
                <a-button @click="prepareToCreate()">Crear anuncio</a-button>
            </a-col>
        </a-row>

        <div class="announcements-grid" style="height: 1110px;">
            <div v-for="(announcement, key) in announcements" class="flexmasonry-item" :key="key">
                <div class="announcement-box">
                    <div class="announcement-box-header">
                        <h2>{{ announcement.title | ellipseOn(60) }}</h2>
                    </div>
                    <div class="announcement-box-body">
                        {{ announcement.content | Untag | ellipseOn(200) }} <br>
                        <small class="ml-2">
                            {{ new Date(announcement.created_at).toLocaleDateString() }}
                        </small><br>
                    </div>
                    <div class="announcement-box-footer">

                        <div class="announcement-box-action-buttons">
                            <template v-if="loggedUserIsAdmin">
                                <a-popconfirm
                                    title="Seguro que desea eliminar esta noticia?"
                                    @confirm="deleteAnnouncement(announcement)"
                                    okText="Si"
                                    cancelText="No">
                                    <span class="flat-button text-danger c-pointer">
                                        Eliminar
                                    </span>
                                </a-popconfirm>
                                <span class="flat-button is-link" @click="prepareToEdit(announcement)">
                                    Editar
                                </span>
                            </template>
                            <router-link :to="`/announcements/${announcement.id}`" class="flat-button">
                                <span @click="setAnnouncement(announcement)">
                                    Ver
                                </span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a-drawer
            :title="selected ? 'Actualizar anuncio' : 'Crear nuevo anuncio'"
            height="80%"
            placement="bottom"
            :closable="false"
            @close="setVisible(false)"
            :visible="visible">

            <div class="m-2">
                <a-row type="flex">
                    <a-input placeholder="Titulo" v-model="title" class="d-block mb-1" @keydown="removeError('title')"/>
                    <span class="mb-1 text-danger" v-if="hasError('title')">{{ getTranslatedError('title') }}</span>
                    <a-row class="w-100p" :gutter="8">
                        <a-col :xs="24" :sm="24" :md="12" :lg="12">
                            <div class="editor-content-box">
                                <div class="editor-content-tools">

                                    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                                        <div class="menubar is-active">

                                            <button :class="['menubar__button', { 'is-active': isActive.bold() }]" @click="commands.bold">
                                                <a-icon type="bold" />
                                            </button>

                                            <button :class="['menubar__button', { 'is-active': isActive.italic() }]" @click="commands.italic">
                                                <a-icon type="italic" />
                                            </button>

                                            <button :class="['menubar__button', { 'is-active': isActive.strike() }]" @click="commands.strike">
                                                <a-icon type="strikethrough" />
                                            </button>

                                            <button :class="['menubar__button', { 'is-active': isActive.underline() }]" @click="commands.underline">
                                                <a-icon type="underline" />
                                            </button>

                                            <button :class="['menubar__button', { 'is-active': isActive.code() }]" @click="commands.code" >
                                                <a-icon type="code" />
                                            </button>

                                            <button :class="['menubar__button', { 'is-active': isActive.paragraph() }]" @click="commands.paragraph" >
                                                P
                                            </button>

                                            <button :class="['menubar__button', { 'is-active': isActive.heading({ level: 1 }) }]" @click="commands.heading({ level: 1 })" >
                                                H1
                                            </button>

                                            <button :class="['menubar__button', { 'is-active': isActive.heading({ level: 2 }) }]" @click="commands.heading({ level: 2 })" >
                                                H2
                                            </button>

                                            <button :class="['menubar__button', { 'is-active': isActive.heading({ level: 3 }) }]" @click="commands.heading({ level: 3 })" >
                                                H3
                                            </button>
                                        </div>
                                    </editor-menu-bar>

                                    <div class="editor">
                                        <editor-menu-bubble :editor="editor" v-slot="{ commands, isActive, getMarkAttrs, menu }" class="menububble" @hide="hideLinkMenu">
                                            <div class="menububble" :class="{ 'is-active': menu.isActive }" :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`">
                                                <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
                                                    <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
                                                    <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
                                                        <a-icon type="link" />
                                                    </button>
                                                </form>

                                                <template v-else>
                                                    <button class="menububble__button" @click="showLinkMenu(getMarkAttrs('link'))" :class="{ 'is-active': isActive.link() }">
                                                        <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>
                                                        <a-icon type="link" />
                                                    </button>
                                                </template>
                                            </div>
                                        </editor-menu-bubble>
                                    </div>
                                </div>
                                <div class="editor-content-body">
                                    <editor-content class="editor__content" :editor="editor" />
                                </div>
                            </div>
                            <span class="mt-1 text-danger" v-if="hasError('content')">{{ getTranslatedError('content') }}</span> <br>
                            <div class="d-flex justify-content-between">
                                <a-upload :action="`${apiURL}/api/upload-file-ad`" name="file" :headers="{'Authorization': `Bearer ${getToken()}`}" class="ml-1" :file-list="fileList" @change="handleChange">
                                    <a-button :disabled="fileList.length > 0">
                                        <a-icon type="upload" /> Subir doc
                                    </a-button>
                                </a-upload>
                                <a-button :loading="isLoading" v-if="!selected" @click="createAnnouncement()">
                                    Publicar anuncio
                                </a-button>
                                <a-button :loading="isLoading" v-else @click="updateAnnouncement({ title, content, id: selected.id })">
                                    Actualizar anuncio
                                </a-button>
                            </div>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="12" :lg="12">
                            <div class="editor-content-box">
                                <div class="editor-content-body">
                                    <h2 class="mb-1">{{ title }}</h2>
                                    <div v-html="content"></div>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                </a-row>
            </div>
        </a-drawer>
    </a-spin>
</template>

<script>
import { getCookie } from '@/helpers/storage'
import { URL } from '@/constants'
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import { Editor, Doc } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Placeholder
} from 'tiptap-extensions'
import FlexMasonry from 'flexmasonry/src/flexmasonry.js';

export default {
    data: () => ({
        editor: null,
        content: '',
        title: '',
        selected: null,
        linkUrl: null,
        linkMenuIsActive: false,
        fileList: [],
        apiURL: URL,
        fileId: null
    }),
    computed: {
        ...mapGetters({
            loggedUserIsAdmin: 'session/loggedUserIsAdmin',
            hasError: 'hasError',
            getTranslatedError: 'getTranslatedError'
        }),
        ...mapState({
            announcements: state => state.announcements.announcements,
            visible: state => state.announcements.visibleCreate,
            isLoading: state => state.announcements.isLoading
        })
    },
    methods: {
        ...mapActions({
            setAnnouncement: 'announcements/set',
            getAnnouncements: 'announcements/get',
            storeAnnouncement: 'announcements/store',
            updateAnnouncement: 'announcements/update',
            deleteAnnouncement: 'announcements/delete',
            removeError: 'removeError',
        }),
        ...mapMutations({
            setVisible: 'announcements/SET_VISIBLE_CREATE',
        }),
        prepareToCreate() {
            this.selected = null;
            this.editor.setContent('');
            this.content = '';
            this.title = '';
            this.setVisible(true)
        },
        prepareToEdit(announcement) {
            this.selected = announcement;
            this.title = announcement.title;
            this.editor.setContent(announcement.content);
            this.content = announcement.content;
            this.setVisible(true)
        },
        showLinkMenu(attrs) {
            this.linkUrl = attrs.href;
            this.linkMenuIsActive = true;
            this.$nextTick(() => {
                this.$refs.linkInput.focus()
            })
        },
        hideLinkMenu() {
            this.linkUrl = null;
            this.linkMenuIsActive = false
        },
        setLinkUrl(command, url) {
            command({ href: url, target: '_blank' });
            this.hideLinkMenu()
        },
        handleChange(info) {
            let fileList = [...info.fileList];

            fileList = fileList.map(file => {

                if (file.response) {
                    file.url = file.response.path
                    this.fileId = file.response.id
                }


                return file;
            });

            this.fileList = fileList;
        },
        getToken() {
            return localStorage.getItem(process.env.VUE_APP_USER_TOKEN_NAME)
        },
        createAnnouncement() {
            this.storeAnnouncement({
                title: this.title,
                content: this.content,
                file_id: this.fileId,
                cb: () => {
                    this.file_id = null;
                    this.fileList = [];
                    this.prepareToCreate()
                }
            })

        }
    },
    mounted() {
        this.getAnnouncements();
        this.editor = new Editor({
            onUpdate: (context) => {
                this.content = context.getHTML();
                this.removeError('content')
            },
            extensions: [
                new Blockquote(),
                new BulletList(),
                new CodeBlock(),
                new HardBreak(),
                new Heading({ levels: [1, 2, 3] }),
                new HorizontalRule(),
                new ListItem(),
                new OrderedList(),
                new TodoItem(),
                new TodoList(),
                new Link(),
                new Bold(),
                new Code(),
                new Italic(),
                new Strike(),
                new Underline(),
                new History(),
                new Placeholder({
                    emptyEditorClass: 'is-editor-empty',
                    emptyNodeClass: 'is-empty',
                    emptyNodeText: 'Anuncio...',
                    showOnlyWhenEditable: true,
                    showOnlyCurrent: true,
                })
            ],
        });
    },
    filters: {
        Untag(val) {
            return val.replace(/<\/?[^>]+(>|$)/g, "")
        },
        ellipseOn(val, max) {
            if (val.length > max) {
                return `${val.substring(0, max)}...`
            }

            return val
        }
    },
    updated() {
        FlexMasonry.init('.announcements-grid', {
            numCols: 5,
            responsive: true,
            breakpointCols: {
                'min-width: 1500px': 4,
                'min-width: 1200px': 3,
                'min-width: 992px': 3,
                'min-width: 768px': 2,
                'min-width: 576px': 1,
            },
        })
    }
}
</script>

<style lang="scss">
p.is-editor-empty:first-child::before {
  content: attr(data-empty-text);
  float: left;
  color: #aaa;
  pointer-events: none;
  height: 0;
  font-style: italic;
}
</style>
